import {Component, EventEmitter, OnInit, ViewChild} from '@angular/core';
import {ResellersService} from "../../services/resellers.service";
import {Reseller} from "../../models/reseller.model";
import {Subject} from "rxjs";
import {UserService} from "../../services/user.service";
import {ChoiceService} from "../../services/choice.service";
import {Choice} from "../../models/choice.enum";
import {CountriesService} from "../../services/countries.service";
import {Country} from "../../models/country.model";
import {mapStyles} from "../../data/mapStyle.const";
import {environment} from "../../../environments/environment";
import {StepsService} from "../../services/steps.service";


@Component({
    selector: 'app-step3',
    templateUrl: './step3.component.html',
    styleUrls: ['./step3.component.scss']
})
export class Step3Component implements OnInit {

    imgUrl = environment.serverImages
    mapStyle = mapStyles

    featured: Reseller[] = [];
    featured$: Subject<Reseller[]> = new Subject<Reseller[]>();
    distributor: Reseller[] = [];
    resellersWithService: Reseller[] = [];
    resellers: Reseller[] = [];
    fullResellers: Reseller[] = [];
    filteredResellersList: Reseller[];
    country: string;
    countries: Country[];
    loading: false;
    geocoder = new google.maps.Geocoder();
    map: any;
    fullEmpty = false;

    constructor(private resellerSrv: ResellersService,
                private user: UserService,
                private choice: ChoiceService,
                private countriesSrv: CountriesService,
                private stepSrv: StepsService) {
    }

    ngOnInit(): void {

        this.countriesSrv.countries$.subscribe(countries => {
            this.countries = countries;
        })


        this.user.country$.subscribe(country => {
            this.country = country;

        })

        this.resellerSrv.resellers$.subscribe(resellers => {
                this.fullResellers = resellers;
                this.changeCountry()
            }
        )
    }

    get isIndustrial(): boolean {
        if (this.choice.selectedDevice) {
            return this.choice.selectedDevice.technology === 'industrial';
        }
        return false;

    }

    get isService(): boolean {
        return this.choice.choice === Choice.service;
    }

    get isApoller(): boolean {
        return this.choice.selectedDevice.id === 'apoller';
    }

    mapReady(map) {
        this.map = map;
    }

    mapResellers() {
        this.featured = [];
        this.distributor = [];
        this.resellersWithService = [];
        this.resellers = [];

        const filteredResellersList = this.fullResellers
            .filter(reseller => { //check reseller country
                if (!this.country) {
                    return true;
                }

                if (reseller.countryName === this.country) {
                    return true;
                }

                if (reseller.service_regions.length) {
                    const hasService = reseller.service_regions.filter(region => {
                        if (region.country_code === this.country) {
                            return true;
                        }
                        return false;
                    })

                    if (hasService.length) {
                        return true;
                    }
                }

                return false;
            })
            .filter(reseller => { //check is technology similar with reseller

                if (this.choice.selectedDevice && this.choice.choice) {
                    //sprawdź czy reseller w ogóle obsługuje tą technologię.
                    if (this.choice.choice === Choice.purchase && !reseller.technology[this.choice.selectedDevice.technology]) {
                        return false;
                    }
                    if (this.choice.choice === Choice.service && !reseller.serviceTech[this.choice.selectedDevice.technology]) {
                        return false;
                    }
                    if (reseller.serviceTech[this.choice.selectedDevice.technology] && this.choice.choice === Choice.service) {
                        if (this.choice.selectedDevice.id === 'apoller') {
                            return false;
                        }
                    }
                    /////
                    if (reseller.service_regions.length) {
                        const isService = reseller.service_regions.filter(region => {
                            if (region.country_code !== this.country) {
                                return false;
                            }

                            if (this.choice.selectedDevice.technology === 'industrial' && region.type === 'industrial') {
                                return true;
                            }
                            if (this.choice.selectedDevice.technology !== 'industrial' && region.type === 'service') {
                                if (this.choice.selectedDevice.id === 'apoller' && this.choice.choice === Choice.service) {
                                    return false;
                                }
                                return true;
                            }
                            return false;
                        })

                        if (isService.length) {
                            return true;
                        }
                    }
                    return false;
                }
                return true;
            })

        filteredResellersList.map(reseller => {

            if (reseller.featured) {
                this.featured.push(reseller);
                return;
            }

            if (this.choice.selectedDevice) {
                if (this.choice.selectedDevice.technology === 'industrial' && reseller.types.official_industrial_distributor) {
                    this.distributor.push(reseller);
                    return
                }
                if (this.choice.selectedDevice.technology === 'desktop' && reseller.types.official_distributor) {
                    this.distributor.push(reseller);
                    return
                }
            }

            if (!this.choice.selectedDevice && (reseller.types.official_distributor || reseller.types.official_industrial_distributor)) {
                this.distributor.push(reseller);
                return
            }

            if (reseller.types.service) {
                this.resellersWithService.push(reseller);
                return;
            }

            this.resellers.push(reseller);

        });

        this.fullEmpty = false;
        if (!this.resellersWithService.length
            && !this.featured.length
            && !this.distributor.length
            && !this.resellers.length) {
            this.fullEmpty = true;
        }


        this.filteredResellersList = filteredResellersList;


    }


    listsAreEmpty() {

        return !this.resellers.length && !this.distributor.length
            && !this.featured.length && !this.resellersWithService.length && !this.loading;

    }

    changeCountry() {
        this.mapResellers();
    }

    prevStep() {
        this.stepSrv.prevStep();
    }

}
